const onPremDevDomain = 'https://www.rpsdev.troweprice.com';

export default {
  DEV: {
    INTERNAL: {
      api: 'https://api.rpsdev.fisretirement.net',
      web: 'https://www.rpsdev.fisretirement.net',
      wrs: onPremDevDomain,
    },
    EXTERNAL: {
      api: 'https://api.rpsdev.troweprice.com',
      web: 'https://www.rpsdev.troweprice.com',
      wrs: onPremDevDomain,
    },
  },
  STAGE: {
    INTERNAL: {
      api: 'https://api.rpsstg.fisretirement.net',
      web: 'https://www.rpsstg.fisretirement.net',
      wrs: 'https://www.rpsstg.fisretirement.net',
    },
    EXTERNAL: {
      api: 'https://api.rpsstg.troweprice.com',
      web: 'https://www.rpsstg.troweprice.com',
      wrs: 'https://www.rpsstg.troweprice.com',
    },
  },
  PROD: {
    INTERNAL: {
      api: 'https://api.rps.fisretirement.net',
      web: 'https://www.rps.fisretirement.net',
      wrs: 'https://www.rps.troweprice.com',
    },
    EXTERNAL: {
      api: 'https://api.rps.troweprice.com',
      web: 'https://www.rps.troweprice.com',
      wrs: 'https://www.rps.troweprice.com',
    },
  },
  SANDBOX: {
    EXTERNAL: {
      api: 'https://api.rpsdev.troweprice.com',
      web: 'https://www.rpsdev.troweprice.com',
      wrs: onPremDevDomain,
    },
  },
  LOCALHOST: {
    INTERNAL: {
      api: '',
      web: 'https://www.rpsdev.fisretirement.net',
      wrs: onPremDevDomain,
    },
    EXTERNAL: {
      api: '',
      web: 'https://www.rpsdev.troweprice.com',
      wrs: onPremDevDomain,
    },
  },
}